// ** Next imports

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { FaqSidebar } from "../../components/support/faqPages/";
import PrivacyPolicyText from "../../components/shared/privacyPolicy";

const PrivacyPolicy = () => (
  <Layout>
    <SEOHead title="Privacy Policy" />
    <section className="bg-silver1 pad-top-40 pad-bot-40">
      <div className="container">
        <div className="sec-head">
          <h1 className="no-margin text-center">
            <b>Privacy Policy</b>
          </h1>
        </div>
      </div>
    </section>

    <section className="pad-top-60 pad-bot-60">
      <div className="container">
        <div className="row">
          <div className="col-md-9 col-lg-9 col-sm-9 col-12">
            <PrivacyPolicyText />
          </div>
          <FaqSidebar />
        </div>
      </div>
    </section>
  </Layout>
);

export default PrivacyPolicy;
